import * as React from "react"
import { useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import * as classNames from "./RhJobAdSearchFormSection.module.scss"
import Card from "../../../common/blocks/card/Card"
import Icon from "../../../common/blocks/icon/Icon"
import Button from "../../../common/blocks/button/Button"
import SearchField from "../Component/SearchField"
import SearchCityField from "../Component/SearchCityField"
import SearchTypeContractField from "../Component/SearchTypeContractField"
import CtxHeroSection from "../../../common/sections/ctx-hero-section/CtxHeroSection"
const RhJobAdSearchFormSection = ({
  image,
  showCitySearchField,
  showContractTypeSearchField,
  showJobSearchField,
  title,
  filterResultTitle,
  cancelFilterMessage,
}) => {
  //return <h1>RhJobAdSearchFormSection</h1>

  const [filtredItems, setFiltredItems] = useState([])
  const [filteredSuggestionsItems, setFilteredSuggestionsItems] = useState([])
  const [name, setName] = useState("")
  const [showSuggestion, setShowSuggestion] = useState(false)
  const suggestionsVilles = [
    "Auvergne-Rhone-Alpes",
    "Bourgogne-Franche-Comte",
    "Bretagne",
    "Centre-Val-de-Loire",
    "Corse",
    "Grand-Est",
    "Hauts-de-France",
    "Ile-de-France",
    "Normandie",
    "Nouvelle-Aquitaine",
    "Occitanie",
    "Pays-de-la-Loire",
    "Provence-Alpes-Cote-d-Azur",
  ]
  const data = useStaticQuery(
    graphql`
      {
        strapi {
          jobAdCriterias(filters: { type: { eq: "Type de contrat" } }) {
            data {
              attributes {
                key
                value
                type
              }
            }
          }
        }
      }
    `
  )

  const ContractTypeList = data.strapi.jobAdCriterias.data

  const nameChangeHandler = (e) => {
    const userInput = e.currentTarget.value
    setName(userInput)
    const filteredSuggestions = suggestionsVilles.filter(
      (suggestion) =>
        suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    )
    setFilteredSuggestionsItems(filteredSuggestions)
    if (!userInput) {
      setFilteredSuggestionsItems([])
    }
  }
  const addFiltredItems = (e) => {
    if (e.keyCode === 13) {
      setFiltredItems([...filtredItems, e.target.value])
      e.target.value = ""
      setName("")
      setFilteredSuggestionsItems([])
    }
  }
  const deleteOneFiltre = (props) => {
    setFiltredItems(
      filtredItems.filter((el, i) =>
        !isNaN(props) ? props !== i : props !== el
      )
    )
  }

  return (
    <CtxHeroSection
      image={image}
      imgSrc={image?.data?.attributes.url}
      key="RhJobAdSearchFormSection"
    >
      <div className="container">
        <Card className="flex card_bottom flex-direction-column align-items-center justify-content-center p-6 gap-4">
          <h1 className="text-center">{title}</h1>
          <div
            className={classNames.jobSearch}
            key="JobSearch"
          >
            {showJobSearchField && (
              <SearchField
                classe={`${classNames.column} ${classNames.searchLocation}`}
                labelle="JobSearch"
                id="JobSearch"
                placeholder="Commercial"
                icon="loupe"
                filtredItems={filtredItems}
                setFiltredItems={setFiltredItems}
                name={name}
                setName={setName}
              />
            )}
            {showCitySearchField && (
              <SearchCityField
                classe={`${classNames.column} ${classNames.searchLocation}`}
                filtredItems={filtredItems}
                setFiltredItems={setFiltredItems}
                name={name}
                setName={setName}
              />
            )}
            {showContractTypeSearchField && (
              <SearchTypeContractField
                classe={`${
                  classNames.column + " " + classNames.searchLocation
                }`}
                filtredItems={filtredItems}
                setFiltredItems={setFiltredItems}
                name={name}
                setName={setName}
              />
            )}
          </div>
          {filtredItems.length !== 0 && (
            <div className="text-center">
              <h5 className="mb-2">{filterResultTitle}</h5>
              <div className="flex">
                <div className="tags mr-1">
                  {filtredItems.map((item, index) => {
                    return (
                      <Button
                        key={index}
                        aspect="tag"
                        size="large"
                        color="primary"
                        className={classNames.resulatButton}
                        onClick={(e) => deleteOneFiltre(index)}
                      >
                        <Icon
                          icon="cross"
                          key={"icone_" + index}
                          width="15"
                          height="15"
                        />
                        {item}
                      </Button>
                    )
                  })}
                </div>
                <Button
                  aspect="unstyled"
                  className="fs-16 secondary-text-color"
                  onClick={() => {
                    setShowSuggestion(false)
                    setFiltredItems([])
                  }}
                >
                  <Icon icon="arrowRight" />
                  {cancelFilterMessage}
                </Button>
              </div>
            </div>
          )}
        </Card>
      </div>
    </CtxHeroSection>
  )
}

export const name = "RhJobAdSearchFormSection"

export const init = (componentData, pageContext) => {
  return (
    <RhJobAdSearchFormSection
      key={componentData.id}
      title={componentData.titleSearchAdsHeader}
      imageUrl={componentData.image.data?.attributes.url}
      image={componentData.image?.data?.attributes}
      showCitySearchField={componentData.showCitySearchField}
      showJobSearchField={componentData.showJobSearchField}
      showContractTypeSearchField={componentData.showContractTypeSearchField}
      filterResultTitle={componentData.filterResultTitle}
      cancelFilterMessage={componentData.cancelFilterMessage}
    />
  )
}

export default RhJobAdSearchFormSection
